angular.module('impactx.catalogruleresult').controller('CatalogRuleTaxRatesListCtrl',
    CatalogRuleTaxRatesListCtrl);

CatalogRuleTaxRatesListCtrl.$inject = ['$routeParams'];

function CatalogRuleTaxRatesListCtrl($routeParams)
{
    this.meta = {
        rowTemplate: 'modules/catalogruleresult/templates/catalogruletaxrateslist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalogruleresult/ruletaxrateslist',
        id: "catalogruletaxrateslist",
        params: {'cmrliId': $routeParams.id},
        excelParams: {
            params: [{param: 'CMRLIId', intValue: $routeParams.id}]
        },
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    }
}